import React, { useState, useEffect } from 'react';
import { Cookies } from "../index.js";
import AdModal from "../app_structure/AdModal_deposit.jsx";
import { alert_error, alert_success } from "../AppContext.js";
import { useNavigate, Link, useLocation } from "react-router-dom";
const Logout = () => {
    const apikey = () => {
        const allCookies = Cookies.get(); // Lấy tất cả các cookie hiện tại
        Cookies.remove('apikey');
        Cookies.remove('national_market');
        for (let cookie in allCookies) {
            // console.log(`${cookie}: ${allCookies[cookie]}`); // Log tên và giá trị của từng cookie
            Cookies.remove(cookie, { path: '/', domain: window.location.hostname }); // Xóa cookie với đường dẫn gốc
        }
        // switch_router('/reactapp/');
    };
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    const [showAd, setShowAd] = useState(true);
    const handleCloseAd = () => {
        setShowAd(false);
        // switch_router('/reactapp/');
    };
    useEffect(() => {
        // Đặt hẹn giờ 2 giây
        const timer = setTimeout(() => {
            apikey();
            // Gọi hàm sau khi đếm ngược 2 giây          apikey();
        }, 2000);
        alert_success('Đăng xuất thành công');
        // Dọn dẹp hẹn giờ khi component unmount
        return () => clearTimeout(timer);
    }, []);
    return (
        <div>
            {/* <button onClick={apikey}>Xóa Cookie</button> */}
            <AdModal isOpen={showAd} onClose={handleCloseAd} switch_router={switch_router} className="mx-auto" />
            { window.location.hostname }
        </div>
    );
}

export default Logout;
